import templateMainAtc from './templates/atc-main.html';
import templateCheck from './atc-check/check-eligibillity.html';
import templateCheckResult from './atc-check-result/check-eligibillity-result.html';
import templateCalendar from './atc-calendar-view/calendar-view.html';
import templateFlights from './atc-flights-view/flights-view.html';
import templateFlightsHeader from './atc-flights-view/flights-header.html';
import templateFlightsList from './atc-flights-view/flights-list.html';
// import templateFlightsCarousel from './atc-flights-view/flights-carousel.html';
import templateFlightsFilters from './atc-flights-view/filters/flight-filters.html';

import AtcMainController from './controllers/atcMainController';
import AtcCheckController from './controllers/atcCheckController';
import AtcCheckResultController from './controllers/atcCheckResultController';
import AtcCalendarController from './controllers/atcCalendarController';
import AtcFlightsController from './controllers/atcFlightsController';
import AtcFlightsHeaderController from './controllers/atcFlightsHeaderController';
import AtcFlightsListController from './controllers/atcFlightsListController';
import AtcFlightFiltersController from './atc-flights-view/filters/flight-filters-controller';
// import AtcFlightsCarouselController from './controllers/atcFlightsCarouselController';

import templateMainFlightsResultsRules from '../base/templates/flights/rules.tmpl.html';
import RulesBaseController from '../base/controllers/flights/rulesBaseCtrl';

export const atcStates = {
    MAIN: 'main.atc',
    CHECK: 'main.atc.check',
    CHECK_RESULT: 'main.atc.result',
    CALENDAR_VIEW: 'main.atc.calendar',
    FLIGHTS_VIEW: 'main.atc.flights',
    FLIGHTS_VIEW_RULES: 'main.atc.flights.rules',
};

export const DEFAULT_CABIN_CLASS_INDEX = 1;

export default function AtcRoutes($stateProvider, $urlRouterProvider) {
    'ngInject';

    $urlRouterProvider.when('/search/atc', '/search/atc/check');

    $stateProvider
        .state(atcStates.MAIN, {
            url: '/atc',
            views: {
                '': {
                    template: templateMainAtc,
                    controller: AtcMainController,
                    resolve: {
                        // settingsCabinClasses: function($rootScope, staticDataGetter) {
                        //     'ngInject';
                        //     return $rootScope.readOnlyMode ? [] : staticDataGetter.getFlightsCabinClasses();
                        // },
                        settingsCabinClasses: function($rootScope, atcFlightsService) {
                            'ngInject';
                            return $rootScope.readOnlyMode ? [] : atcFlightsService.getFlightsCabinClasses();
                        },
                    },
                },
            },
            resolve: {
                atcFlightsFactory: function(atcFFactory) {
                    'ngInject';
                    // eslint-disable-next-line new-cap
                    return new atcFFactory('atc');
                },
            },
        })
        .state(atcStates.CHECK, {
            url: '/check',
            template: templateCheck,
            controller: AtcCheckController,
            controllerAs: '$ctrl',
        })
        .state(atcStates.CHECK_RESULT, {
            url: '/result',
            params: {
                pnr: null,
                trip: null,
                department: null,
                fromTripDetails: null,
            },
            template: templateCheckResult,
            controller: AtcCheckResultController,
            controllerAs: '$ctrl',
        })
        .state(atcStates.CALENDAR_VIEW, {
            url: '/calendar',
            params: {
                searchConditions: null,
            },
            template: templateCalendar,
            controller: AtcCalendarController,
            controllerAs: '$ctrl',
        })
        .state(atcStates.FLIGHTS_VIEW, {
            url: '/flights',
            params: {
                searchConditions: null,
            },
            resolve: {
                previousState: function($state) {
                    'ngInject';
                    return {
                        name: $state.current.name,
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params),
                    };
                },
            },
            views: {
                '@main': {
                    template: templateFlights,
                    controller: AtcFlightsController,
                    controllerAs: 'flightResultsCtrl',
                },
                [`flights_header@${atcStates.FLIGHTS_VIEW}`]: {
                    template: templateFlightsHeader,
                    controller: AtcFlightsHeaderController,
                    controllerAs: 'flightsHeaderCtrl',
                },
                [`flights_filters@${atcStates.FLIGHTS_VIEW}`]: {
                    template: templateFlightsFilters,
                    controller: AtcFlightFiltersController,
                    controllerAs: 'flightFiltersCtrl',
                },
                // [`flights_carousel@${atcStates.FLIGHTS_VIEW}`]: {
                //     template: templateFlightsCarousel,
                //     controller: AtcFlightsCarouselController,
                // },
                [`flights_list@${atcStates.FLIGHTS_VIEW}`]: {
                    template: templateFlightsList,
                    controller: AtcFlightsListController,
                    controllerAs: 'flightsListCtrl',
                },
            },
        })

        .state(atcStates.FLIGHTS_VIEW_RULES, {
            url: '/rules?fare&recommendation&adult&child&infant&search&groups&anchor&culture',
            params: {
                groups: {array: true},
            },
            resolve: {
                anchorLink: function($stateParams) {
                    'ngInject';
                    return $stateParams.anchor;
                },
                rules: function($stateParams, atcFlightsFactory) {
                    'ngInject';
                    return atcFlightsFactory.getRules({
                        searchId: $stateParams.search,
                        fareId: $stateParams.fare,
                        recommendationId: $stateParams.recommendation,
                        adultCount: $stateParams.adult,
                        childCount: $stateParams.child,
                        infantCount: $stateParams.infant,
                        flightGroups: $stateParams.groups,
                        culture: $stateParams.culture,
                    });
                },
            },
            views: {
                '@main': {
                    template: templateMainFlightsResultsRules,
                    controller: RulesBaseController,
                },
            },
        });
}




// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-routes.js